import React, {StrictMode} from "react";
import {Motorization} from "@App/types";
import {useDates} from "@App/hooks/useDates";

type MotorizationListItemProps = {
    motorization: Motorization
    onClick: (motorization: Motorization) => void
}

export const MotorizationListItem = React.memo<MotorizationListItemProps>((props: MotorizationListItemProps) => {

    const {formatDate} = useDates()

    return (
        <StrictMode>
            <div className="
                    w-full
                    py-3
                    border-b border-neutral-100
                    cursor-pointer"
                 onClick={() => props.onClick(props.motorization)}>
                <div className="text-neutral-700">{props.motorization.name.toUpperCase()} / {props.motorization.ps} PS
                    ({props.motorization.kw} kW)
                </div>
                <div className="text-neutral-500 text-sm">
                    {props.motorization.fuelType.name}
                    <span className="mx-1">|</span>
                    {formatDate(props.motorization.built_from, 'MM-yyyy')} - {props.motorization.built_to ? formatDate(props.motorization.built_to, 'MM-yyyy') : 'heute'}
                    <span className="mx-1">|</span>
                    {props.motorization.displacement} ccm
                </div>
            </div>
        </StrictMode>
    );
})
